<app-admin-panel-user-organization-data-section
  sectionTitle="Adres i numer rachunku bankowego"
  [fields]="fields()"
></app-admin-panel-user-organization-data-section>
